import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Committees = () => {
    const [data, setData] = useState([]);

    return (
        <div className="megaMenuContent">
            <h4>Market Overview</h4>
            {data.length === 0 ? (
                <p>Loading...</p>
            ) : (
                <ul>
                    {data.map((item, i) => (
                        <li key={i}>{item.name} - {item.value}</li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Committees;
